import type { ProductsSearchFilter, ProductsSearchParamsExtended } from '~~/types/product/ProductSearch';
import { DEFAULT_PRODUCT_LIMIT } from '~~/constants/commerceTools';
import type { ProductsSearchParams, ProductWhereSearch } from '~~/types/commercetools';
import { StringBoolean } from '~~/types/StringBoolean';
import { excludeUnsellableProduct } from '~~/helpers/commercetools/graphql/excludeUnsellableProduct';
import type { ProductsSearchCustomParams } from '~~/types/product/ProductsSearchCustomParams';
import { ATTRIBUTE_TYPE, PRODUCT_ATTRIBUTES } from '~~/constants/products';

export const getProductSearchParams = (
  searchParams: ProductsSearchParams | ProductWhereSearch,
  customParams: ProductsSearchCustomParams,
): ProductsSearchParamsExtended => {

  const eligibleForSellingFilter: ProductsSearchFilter = {
    type: ATTRIBUTE_TYPE.LOCALIZED_STRING,
    name: PRODUCT_ATTRIBUTES.ELIGIBLE_FOR_SELLING,
    value: StringBoolean.true,
  };
  let customFiltersForSearch = '';

  if (!customParams?.includeUnsellableProducts) {

    customFiltersForSearch += excludeUnsellableProduct(customParams.languageAndCountry);
  
  }

  if (searchParams?.customFilters) {

    customFiltersForSearch += searchParams.customFilters;
  
  }

  const limit = 'limit' in searchParams ? searchParams.limit : DEFAULT_PRODUCT_LIMIT;

  const searchParamsWithFilter: ProductsSearchParamsExtended = {
    ...searchParams,
    filters: customParams?.includeUnsellableProducts ? [] : [eligibleForSellingFilter],
    limit,
    isOnStock: customParams.isOnStock,
    customFilters: customFiltersForSearch,
  };

  if (customParams.languagePrefix) {

    searchParamsWithFilter.languagePrefix = customParams.languagePrefix;
  
  }

  return searchParamsWithFilter;

};
